import React from "react";
import PropTypes from "prop-types";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import { Tooltip, Switch } from "@material-ui/core";

export const SwitchWithTooltip = ({
  tooltipText,
  disabled,
  onChange,
  text,
  value,
  checked,
  position,
  classNameFormControl,
  classNameSwitch,
  classNameFormGroup,
  classNameLabel,
  ...other
}) => {
  return (
    <Tooltip title={tooltipText}>
      <FormControl component="fieldset">
        <FormGroup aria-label="position" className={classNameFormGroup} row>
          <FormControlLabel
            value={value}
            control={
              <Switch
                color="primary"
                value={value}
                disabled={disabled}
                checked={checked}
                text={text}
                onChange={onChange}
                component={disabled ? "div" : undefined}
                className={classNameSwitch}
                {...other}
              />
            }
            label={text}
            labelPlacement={position ?? "top"}
            className={classNameFormControl}
            classes={{
              label: classNameLabel,
            }}
            {...other}
          />
        </FormGroup>
      </FormControl>
    </Tooltip>
  );
};

SwitchWithTooltip.propTypes = {
  tooltipText: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  value: PropTypes.bool,
  checked: PropTypes.bool,
  position: PropTypes.string.isRequired,
  classNameFormControl: PropTypes.string.isRequired,
  classNameSwitch: PropTypes.string.isRequired,
  classNameFormGroup: PropTypes.string.isRequired,
  classNameLabel: PropTypes.string,
};

SwitchWithTooltip.defaultProps = {
  value: false,
  checked: false,
  classNameLabel: "",
};
